import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';

export const isFlexible = (challenge: Challenge): boolean =>
  Boolean(challenge?.settings?.timelineType?.flexible?.duration);
